import api from './APIService';

class WaiverService {
	participantWaivers(userId) {
		return api.fetch({ method: 'get', path: '/participant/waivers/getParticipantWaivers/'+userId });
	}
	participantSignatories(userId) {
		return api.fetch({ method: 'get', path: '/participant/waivers/getParticipantSignatories/'+userId });
	}
	removeSignatory($id){
		return api.fetch({ method: 'delete', path: '/participant/waivers/removeSignatory/'+$id });
	}
	addSignatory(data){
		return api.fetch({ method: 'post', path: '/participant/waivers/addSignatory/', data });
	}
	getParticipantWaiversUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/waivers/getParticipantWaivers', data });
	}
	getOrganizationsWaiwers(){
		return api.fetch({ method: 'get', path: '/participant/waivers/getHasWaiverToSign'})
	}
	rejectedWaiver(data){
		return api.fetch({ method: 'put', path: '/organization/waiver/signSignature', data });
	}
	getHasOrganizationWaiversToSign(data){
		return api.fetch({ method: 'post', path: '/participant/waivers/hasOrganizationWaiversToSign/', data });
	}
	getOrCreateOrganizationWaiverToSign(data){
		return api.fetch({ method: 'post', path: '/participant/waivers/getOrCreateOrganizationWaiverToSign/', data });
	}
	getDocumentsByOrganizationId(organizationId){
		return api.fetch({ method: 'get', path: '/participant/organization/'+organizationId+'/waivers' });
	}
}

export default new WaiverService();